import React from "react";
import "./Footer.css";
import { ThemeContext } from "../../Context/theme";

export const Footer = () => {
  const [{ themename }] = React.useContext(ThemeContext);
  const year = new Date().getFullYear();

  return (
    <>
      <footer className={"section " + themename}>
        <div className="footerBox">
          <p className="footer">
            Made by{" "}
            <a href="#home" className="link">
              Aman Jaiswal
            </a>{" "}
            — Frontend Developer (Angular &amp; React), Indore, India
          </p>
          <p className="footer footer__meta">
            &copy; {year} Aman Jaiswal ·{" "}
            <a href="mailto:aj27757@gmail.com" className="link">
              aj27757@gmail.com
            </a>{" "}
            ·{" "}
            <a
              href="https://github.com/AMAN-JAISWALL"
              className="link"
              target="_blank"
              rel="me noopener noreferrer"
            >
              GitHub
            </a>{" "}
            ·{" "}
            <a
              href="https://www.linkedin.com/in/aman-jaiswal-39a9b1254"
              className="link"
              target="_blank"
              rel="me noopener noreferrer"
            >
              LinkedIn
            </a>
          </p>
        </div>
      </footer>
    </>
  );
};
